import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { Button } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { logPalette } from '../../theme/palette';
import {
  trackerToolbarNeutralOutlineColor,
  trackerToolbarNeutralTextColor,
} from '../../components/TrackerFilter/trackerFilterToolbarStyles';

export type DownloadCSVButtonUIColor = 'mediaInteraction' | 'primary' | 'primaryDarker' | 'tertiaryDark';

interface DownloadCSVButtonUIProps {
  onClick: () => void;
  color: DownloadCSVButtonUIColor;
  variant?: 'contained' | 'outlined';
  headerBlue?: string;
  headerBlueHover?: string;
  headerAccentSoft?: string;
  headerAccentSoftHover?: string;
}

export default function DownloadCSVButtonUI(props: Readonly<DownloadCSVButtonUIProps>) {
  const {
    onClick,
    color,
    variant = 'contained',
    headerBlue,
    headerBlueHover,
    headerAccentSoft,
    headerAccentSoftHover,
  } = props;

  let colorOverrides = {};
  if (headerBlue && variant === 'contained') {
    colorOverrides = {
      backgroundColor: headerBlue,
      color: '#FFFFFF',
      '&:hover': {
        backgroundColor: headerBlueHover ?? headerBlue,
      },
    };
  }
  if (headerBlue && variant === 'outlined') {
    colorOverrides = {
      color: trackerToolbarNeutralTextColor,
      borderColor: trackerToolbarNeutralOutlineColor,
      backgroundColor: headerAccentSoft ?? 'transparent',
      '&:hover': {
        borderColor: trackerToolbarNeutralOutlineColor,
        backgroundColor: headerAccentSoftHover ?? alpha('#0F172A', 0.04),
      },
      '& .MuiButton-startIcon .MuiSvgIcon-root': {
        color: logPalette.service.main,
      },
    };
  }

  return (
    <Button
      sx={{
        height: '32px',
        textTransform: 'none',
        fontFamily: '"Open Sans", Arial, sans-serif',
        fontSize: '0.9rem',
        fontWeight: 400,
        ...colorOverrides,
      }}
      variant={variant}
      color={color}
      startIcon={<SaveAltIcon />}
      onClick={() => onClick()}
    >
      Download
    </Button>
  );
}
